<ng-container *ngIf="state$ | async as state">
    <!-- No click handler on the backdrop: a stray click never declines a call (ITP-E-191-01). -->
    <div class="incoming-call-backdrop" *ngIf="state.phase === 'incoming'">
        <div #card class="incoming-call" role="alertdialog" aria-modal="true"
             aria-labelledby="incoming-call-kind incoming-call-who" aria-describedby="incoming-call-context"
             (keydown)="onKeydown($event)">
            <!-- The Video call button rings as video (ITP-E-182-05). -->
            <p class="incoming-call-kind" id="incoming-call-kind">
                <i class="fa-solid" [class.fa-video]="state.mode === 'video'" [class.fa-phone]="state.mode !== 'video'" aria-hidden="true"></i>
                <span class="incoming-call-label">{{ state.mode === 'video' ? 'Incoming video call' : 'Incoming voice call' }}</span>
            </p>
            <div class="incoming-call-face" aria-hidden="true">
                <span class="incoming-call-pulse"></span>
                <span class="incoming-call-avatar" [attr.data-tone]="toneOf(state.peerName)">{{ initialsOf(state.peerName) }}</span>
            </div>
            <p class="incoming-call-who" id="incoming-call-who">{{ state.peerName || 'Someone' }}</p>
            <p class="incoming-call-context" id="incoming-call-context">{{ contextOf(state) }}</p>
            <!-- The two answers share a row, Decline left of Accept; Audio only takes its own row under them so a video
                 call's three buttons never run outside the card (ITP-E-193-01). -->
            <div class="incoming-call-actions">
                <button type="button" class="incoming-call-button incoming-call-decline" (click)="onDecline()">
                    <i class="fa-solid fa-phone-hangup" aria-hidden="true"></i>
                    <span class="incoming-call-button-text">Decline</span>
                </button>
                <button #acceptButton type="button" class="incoming-call-button incoming-call-accept" (click)="onAccept()">
                    <i class="fa-solid" [class.fa-video]="state.mode === 'video'" [class.fa-phone]="state.mode !== 'video'" aria-hidden="true"></i>
                    <span class="incoming-call-button-text">{{ state.mode === 'video' ? 'Accept with video' : 'Accept' }}</span>
                </button>
            </div>
            <button *ngIf="state.mode === 'video'" type="button" class="incoming-call-button incoming-call-audio-only"
                    (click)="onAudioOnly()"><span class="incoming-call-button-text">Audio only</span></button>
            <button type="button" class="incoming-call-button incoming-call-reply" (click)="onReply()"><span class="incoming-call-button-text">Reply with message</span></button>
        </div>
    </div>
</ng-container>
